<template>
  <div class="d-flex align-top">
    <v-autocomplete v-if="!!items && !!items.length" v-model="computedValue" :items="items" :loading="loading" dense
                    label="نام دسته بندی" outlined @update:search-input="lazySearchInput = $event">
      <template v-slot:no-data>
        <v-card class="d-flex align-center px-2" flat width="100%">
          دسته بندی یافت نشد!
          <v-spacer/>
          <v-btn :loading="loading" color="primary" depressed @click="fetch(lazySearchInput)">
            ایجاد دسته بندی و آپلود
          </v-btn>
        </v-card>
      </template>
    </v-autocomplete>

    <v-text-field v-else v-model="computedValue" :loading="loading" dense label="نام دسته بندی" outlined/>

    <v-btn class="ml-2" color="error" outlined @click="$emit('clear')">
      لغو
    </v-btn>
    <v-btn :disabled="!computedValue" :loading="loading" color="success" depressed @click="fetch">
      ثبت
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "catToUpload",

  props: {
    value: String,
    items: Array,
    loading: Boolean
  },

  data: () => ({
    lazySearchInput: '',
  }),

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    fetch(name = null) {
      if (!!name)
        this.$emit('action', name);
      else
        this.$emit('action')

      // this.$root.$emit('fetchCategories')
    }
  }
}
</script>

<style scoped>

</style>